import React, {useContext, useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router-dom';
import { Drawer, DrawerContent, DrawerItem } from '@progress/kendo-react-layout';
import PageManagement from '../../pages/PageManagement';
import LabelsManagement from '../../pages/LabelsManagement';
import RepositoryManagement from '../../pages/RepositoryManagement';
import SystemMessagesManagement from '../../pages/SystemMessagesManagement';
import BannersManagement from '../../pages/BannersManagement';
import {LocalizationContext} from '../../contexts';
import {pages} from '../../config';
import './index.scss';
import NewItem from '../RepositoryItemEditor/new-item';

export default function Routes(props) {
    const history = useHistory();
    const {pathname} = useLocation();
    const [localization, setLocalization] = useContext(LocalizationContext);
    const [drawerItems, setDrawerItems] = useState(
      [
        { text: localization.labels.menu.pages, icon: 'k-i-track-changes-enable', id: "1", isparent: "true", isopen: "false"},
        ...(pages.map((page, i) => {
          return {text: localization.labels.menu['page_' + page.key], icon: page.icon, route: '/page/' + page.key  , id: "1_" + i, parentid: "1", visible: false};
        })),
        { separator: true },
        { text: localization.labels.menu.internal_pages, icon: 'k-i-thumbnails-up', route: '/internalPages' , id: "4"},
        { separator: true },
        { text: localization.labels.menu.systemMessages, icon: 'k-i-information', id: "2", isparent: "true", isopen: "false"},
        { text: localization.labels.menu.systemMessages_elite, icon: 'k-i-align-stretch-element-horizontal', route: '/systemMessages/elite', id: "2_1", parentid: "2", visible: false, show_content_language: '1'},
        { text: localization.labels.menu.systemMessages_dominate, icon: 'k-i-size-to-grid', route: '/systemMessages/dominate', id: "2_2", parentid: "2", visible: false, show_content_language: '1'},
        { separator: true },
        //{ text: localization.labels.menu.labels, icon: 'k-i-textbox', route: '/labels' , id: "2"},
        //{ separator: true },
        { text: localization.labels.menu.repository, icon: 'k-i-folder', id: "3", isparent: "true", isopen: "false"},
        { text: localization.labels.menu.edit_existing_items, icon: 'k-i-folder-more', route: '/repository', id: "3_1", parentid: "3", visible: false, show_content_language: '1'},
        { text: localization.labels.menu.add_new_items, icon: 'k-i-folder-add', route: '/newItem', id: "3_2", parentid: "3", visible: false, show_content_language: '1'},
        { separator: true }
      ]
    );

    useEffect(() => {
      let items = [...drawerItems];

      items.filter(item => item.selected).map(item => {
        item.selected = false;
        return null;
      });
      items.filter(item => item.isparent !== "true" && (item.route == pathname || pathname.startsWith(item.route + '/'))).map(item => {
        item.selected = true;
        setLocalization({show_content_language: !!item.show_content_language});
        if(item.parentid) {
          trigerParetn(item.parentid, "true", items);
        }
        return null;
      });

      setDrawerItems(items);

      // Collapse drawer when entering the labels page
      if (pathname === '/labels' && props.setOpenDrawer) {
        props.setOpenDrawer(false);
      }
    }, [pathname]);

    const trigerParetn = (id, isopen, items) => {
      var parent = items.find(item => item.isparent === "true" && item.id === id);
      if(parent) {
        parent.isopen = isopen;
        items.filter(item => item.parentid === id).map(item => {
          item.visible = isopen === "true";
          return null;
        })
        if(isopen === "true" && parent.parentid) {
          trigerParetn(parent.parentid, "true", items);
        }
      }
    };

    const itemClick = (e) => {
      let item = e.itemTarget.props;

      if(item.isparent === "true") {
        let  items = [...drawerItems];
        trigerParetn(item.id, item.isopen === "true" ? "false" : "true", items);
        setDrawerItems(items);
      }
      else if(!item.selected) {
        history.push(item.route);
      }
    };

    const openDrawer = props.openDrawer;
    const CustomItem = (props) => {
      const { visible, istitle, ...others } = props;

      let classL = [];
      if(istitle) classL.push('k-state-title');
      if(others.isparent === "true") classL.push('k-state-parent');
      if(others.isopen === "true") classL.push('k-state-open');
      classL = classL.join(' ');
    
      return (
          <>
            {
              props.visible === false ? null :
              <DrawerItem {...others} className={classL} title={openDrawer ? '' : props.text}>
                <span className={'k-icon ' + props.icon} />
                <span className={'k-item-text'}>{props.text}</span>
              </DrawerItem>
            }
          </>
      );
    };

    return (
        <div className="app-content">
          <Drawer
              dir={localization.labels.dir}
              expanded ={props.openDrawer}
              items={drawerItems}
              item={CustomItem}
              position='start' 
              mode='push' 
              mini={true}
              onSelect={itemClick}
          >
              <DrawerContent>
                  <Switch>
                    <Route path={'/page/:page/:pageLang?/:section?'} component={PageManagement}></Route>
                    <Route path={'/labels'} component={LabelsManagement}></Route>
                    <Route path={'/systemMessages/:systemMessagesType?/:lang?'} component={SystemMessagesManagement}></Route>
                    <Route path={'/repository/:disciplineID?/:itemID?'} component={RepositoryManagement}></Route>
                    <Route path={'/newItem'} component={NewItem}></Route>
                    <Route path={'/internalPages/:bannerID?'} component={BannersManagement}></Route>
                  </Switch>
              </DrawerContent>
          </Drawer>
        </div>
    );
};